import { __rest } from 'tslib';

const extractMarginProps = (props) => {
    const { margin, mt, mr, mb, ml } = props, rest = __rest(props, ["margin", "mt", "mr", "mb", "ml"]);
    return {
        $margin: margin,
        $marginTop: mt,
        $marginRight: mr,
        $marginBottom: mb,
        $marginLeft: ml,
        rest,
    };
};

export { extractMarginProps };
//# sourceMappingURL=extractMarginProps.js.map
